const mediaItems = [
  {
    id: 1,
    title: '庆余年 · 第二季',
    desc: '范闲归来，权谋升级，京都风云再起',
    tag: '古装权谋',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20palace%20corridor%20in%20warm%20golden%20light%2C%20silhouetted%20figure%20in%20traditional%20robe%2C%20atmospheric%20haze%2C%20cinematic%20composition%2C%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20lighting&width=600&height=400&seq=media-card-01&orientation=landscape'
  },
  {
    id: 2,
    title: '狂飙 · 全集热播',
    desc: '扫黑除恶，高能剧情引爆全网热议',
    tag: '刑侦悬疑',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20atmosphere%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20dark%20moody%20tone%2C%20noir%20lighting%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20streetlights%20against%20dark%20shadows&width=600&height=400&seq=media-card-02&orientation=landscape'
  },
  {
    id: 3,
    title: '繁花 · 沪上风云',
    desc: '九十年代上海滩，商海沉浮人生百态',
    tag: '年代商战',
    img: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20dusk%2C%20vintage%20neon%20signs%2C%20wet%20pavement%20reflections%2C%20warm%20golden%20hour%20glow%2C%20nostalgic%20atmosphere%2C%20film%20grain%20texture%2C%20cinematic%20urban%20scene&width=600&height=400&seq=media-card-03&orientation=landscape'
  },
  {
    id: 4,
    title: '长相思 · 仙侠巨制',
    desc: '上古神话，虐恋纠葛，唯美仙侠之旅',
    tag: '仙侠爱情',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20misty%20waterfalls%2C%20ancient%20temple%20on%20cliff%2C%20soft%20diffused%20light%2C%20warm%20peach%20and%20gold%20tones%2C%20dreamy%20atmosphere%2C%20cinematic%20wide%20shot&width=600&height=400&seq=media-card-04&orientation=landscape'
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            精彩看点
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            本周最受关注的精选剧集，每一部都值得一看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-accent-300/50 transition-all duration-300"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-play-fill text-white text-sm"></i>
                    </div>
                    <span className="text-white text-xs">立即观看</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}